module.exports = __webpack_public_path__ + "img/data1.4d7fffc6.svg";